import { render, staticRenderFns } from "./CardTrainingIcon.vue?vue&type=template&id=94db74f4&scoped=true&"
import script from "./CardTrainingIcon.vue?vue&type=script&lang=js&"
export * from "./CardTrainingIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardTrainingIcon.vue?vue&type=style&index=0&id=94db74f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94db74f4",
  null
  
)

export default component.exports